export class ProgramMonthlyAdjustmentModel
{
    public January: number;
    public February: number;
    public March: number;
    public April: number;
    public May: number;
    public June: number;
    public July: number;
    public August: number;
    public September: number;
    public October: number;
    public November: number;
    public December: number;

    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
